module.exports = __webpack_public_path__ + "static/media/instagram.41ab529b.svg";